import { makeObservable, observable } from 'mobx'

export default class Campaign {
    id

    type

    title

    domain

    langcode

    onsite

    surveyId

    uuid

    /*
        these are used to generate the campaign URL
        {
            [key: string]: {
                type: 'fixed' | 'merge' // this is informative for the user and drives value encoding
                value: string // this is added to the url
            }
        }
        e.g.
        {
            UID: {
                type: 'merge'
                value: '[UID]'
            }
        }

        -> ${baseUrl}?UID=[UID]
    */
    @observable tracking

    constructor({
        campaignId = 0,
        surveyId_txt,
        campaigntitle,
        uuid,
        langCode,
        onsite,
        campaignType,
        domain,
        tracking = {},
    }) {
        this.id = campaignId
        this.surveyId = surveyId_txt
        this.title = campaigntitle
        this.uuid = uuid
        this.type = campaignType
        this.langcode = langCode
        this.onsite = onsite
        this.domain = domain

        this.tracking = tracking ?? {}

        makeObservable(this)
    }

    url(survey, useLatestUI) {
        const baseURL = survey.getPreviewLink(false, useLatestUI)

        const queryParams = {
            campaignuuid: {
                value: this.uuid,
            },
            langcode: {
                value: this.langcode,
            },
            ...this.tracking,
        }

        const query = Object.entries(queryParams)
            .filter(([, { value }]) => value)
            .map(([variable, { value, type }]) => `${variable}=${type === 'merge' ? value : encodeURI(value)}`)
            .join('&')

        if (!query) return baseURL
        return `${baseURL}&${query}`
    }

    toJSON() {
        return {
            campaignId: this.id,
            title: this.title,
            type: 1,
            langcode: this.langcode,
            onSite: this.onsite,
            campaignType: this.type,
            domain: this.domain,
            tracking: this.tracking,
        }
    }
}
